import { useState } from "react";

const photos = [
  { file: "jen02535", alt: "T+A Solitaire T Cognac White headphones folded inside their cognac carrying case" },
  { file: "jen02523", alt: "T+A Solitaire T Cognac White headphones beside their carrying case and sunglasses" },
  { file: "jen02482", alt: "T+A Solitaire T Cognac White headphones held by the cognac headband" },
];
const source = (file: string) => `/clarity-website/personal-audio/solitaire-t-cognac-${file}.webp`;

export default function SolitaireCognacGallery({ contained = false }: { contained?: boolean }) {
  const [selected, setSelected] = useState(0);
  return <div aria-label="Solitaire T Cognac White photo gallery" className={`bg-[#211c17] ${contained ? "flex h-full flex-col" : ""}`}>
    <div className={contained ? "min-h-0 flex-1" : "aspect-[4/3]"}>
      <img src={source(photos[selected].file)} alt={photos[selected].alt} loading="lazy" decoding="async" className="h-full w-full object-contain" />
    </div>
    <div className="flex shrink-0 items-center justify-between gap-3 p-4">
      <p className="text-[10px] uppercase tracking-[.2em] text-white/75">Cognac White</p>
      <div className="flex gap-2">{photos.map((photo, index) => <button key={photo.file} type="button" aria-label={`Show photo ${index + 1}: ${photo.alt}`} aria-pressed={selected === index} onClick={() => setSelected(index)} className={`h-14 w-12 overflow-hidden border-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white ${selected === index ? "border-[#d7bd96]" : "border-transparent opacity-60 hover:opacity-100"}`}>
        <img src={source(photo.file)} alt="" loading="lazy" className="h-full w-full object-cover" />
      </button>)}</div>
    </div>
  </div>;
}
